<template>
    <div>
        <div class="invite-head">
            <span> 账号: {{ otherData.account || '暂无' }}</span>
            <span> 邀请总数: {{ otherData.invitationsTotal || 0 }}</span>
            <span> 邀请并升级VIP: {{ otherData.invitationsVipTotal || 0 }}</span>
            <span> 持有ADT: {{ otherData.BigDecimal || 0 }}</span>
            <span> 已领取ADT: {{ otherData.rewardAdtNumber || 0 }}</span>
            <span> 已收回ADT: {{ otherData.recycleAdtNumber || 0 }}</span>
        </div>
        <div class="title">
            <span>邀请考核明细</span>
            <div style="display: flex">
                <span class="init" @click="onInit">初始化</span
                ><span class="export" @click="onExport">导出</span>
            </div>
        </div>
        <el-table :data="userList">
            <!-- <el-table-column prop="email" label="账号ID" /> -->
            <el-table-column prop="address" label="钱包地址">
                <template slot-scope="scope">
                    <span>{{ scope.row.address }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="vipType" label="VIP类型">
                <template slot-scope="scope">
                    <span>{{
                        scope.row.vipType === 0
                            ? '普通'
                            : scope.row.vipType === 1
                            ? '季度VIP'
                            : '年度VIP'
                    }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="vipLevel" label="VIP等级" />
            <el-table-column prop="vipTime" label="开通VIP时间" :formatter="dateFormat" />
            <el-table-column prop="endTime" label="考核周期">
                <template slot-scope="scope">
                    <span
                        >{{ scope.row.startTime | moment }}至{{ scope.row.endTime | moment }}</span
                    >
                </template>
            </el-table-column>
            <el-table-column prop="taskTotal" label="任务总数" />
            <el-table-column prop="completedNumber" label="已完成数量" />
            <el-table-column prop="completionRate" label="完成率" />
            <el-table-column prop="state" label="考核状态">
                <template slot-scope="scope">
                    <span>{{ scope.row.state === 0 ? '未达标' : '已达标' }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="backAdt" label="收回ADT" />
        </el-table>
        <pagination
            :size="pagination.size"
            :total="totalCount"
            :page="pagination.page"
            @pageChanged="pageChanged"
        ></pagination>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import Pagination from 'components/pagination';
import moment from 'moment';
import api from '../../api';
export default {
    name: 'UserList',
    components: {
        Pagination,
    },
    computed: {
        ...mapGetters('assess', ['userList']),
        ...mapState('assess', ['pagination', 'totalCount', 'otherData', 'queryType', 'queryValue']),
    },
    data() {
        return {
            account: '',
            dataList: [],
            userId: '',
            inviteCode: '',
            dialogVisible: false,
            dialogCodeVisibleEdit: false,
            dialogVisibleShow: false,
            dataListUser: [],
            showInfo: {},
            taskData: {},
            total: 0,
            queryCondition: {
                pageNo: 1,
            },
            queryData: {
                search: '',
                page: 1,
                size: 100,
            },
            queryData2: {
                pageNum: 1,
                pageSize: 10,
                queryValue: '',
                queryType: '',
                groupId: '',
                groupType: '',
            },
            saveData: {
                name: '',
                email: '',
                notes: '',
            },
            editData: {
                id: 0,
                name: '',
                email: '',
                notes: '',
            },
        };
    },
    methods: {
        ...mapActions('assess', ['updateVolunteer']),
        pageChanged(pagination) {
            this.$emit('refresh', pagination);
        },
        dateFormat(row, column) {
            return moment(row.createTime).format('YYYY-MM-DD HH:mm:ss');
        },
        onInit() {
            api.initQuery().then(({ data }) => {
                data
                    ? this.$message.success('VIP考核任务初始化成功')
                    : this.$message.error('VIP考核任务初始化失败');
            });
        },
        onExport() {
            if (!this.queryType || !this.queryValue) {
                this.$message.warning('请先输入查询条件');
                return;
            }
            api.export({ queryType: this.queryType, queryValue: this.queryValue }).then(
                (response2) => {
                    const fileName = '持仓分布数据表' + this.condition.time + '.xlsx';
                    const blob = new Blob([response2], { type: 'application/vnd.ms-excel' });
                    if ('download' in document.createElement('a')) {
                        const link = document.createElement('a');
                        link.download = fileName;
                        link.style.display = 'none';
                        link.href = URL.createObjectURL(blob);
                        document.body.appendChild(link);
                        link.click();
                        URL.revokeObjectURL(link.href);
                    } else {
                        navigator.msSaveBlob(blob, fileName);
                    }
                }
            );
        },
    },
};
</script>

<style lang="less" scoped>
@import url('~styles/variables.less');

.title {
    display: flex;
    justify-content: space-between;
    margin: 20px 0 10px;
    padding: 0 15px;
    > span {
        font-size: 14px;
    }
    .export,
    .init {
        width: 60px;
        height: 35px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 4px;
        border: 1px solid #d4d4d4;
        font-size: 13px;
        cursor: pointer;
    }
    .init {
        margin-right: 10px;
    }
}
.invite-head {
    padding-bottom: 15px;
    margin: 20px 0;
    border-bottom: 1px solid #d4d4d4;
    > span {
        font-size: 14px;
        margin-right: 25px;
        &:last-child {
            margin-right: 0;
        }
    }
}
</style>
